import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import styles from "./Venda.module.css";
import load from "../../../../../Images/loading.gif";

function Venda() {
    const { id } = useParams(); // ← pega o ID da URL
    const [venda, setVenda] = useState(null);
    const [loading, setLoading] = useState(true);

    const fetchVenda = async () => {
        try {
            const response = await fetch(`https://eclipsebots.com/api/sales/${id}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                },
                credentials: "include"
            });

            if (!response.ok) {
                throw new Error("Failed to fetch sale");
            }

            const data = await response.json();
            setVenda(data[0]);
        } catch (error) {
            console.error("Erro ao buscar venda:", error);
            setVenda(null);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchVenda();
    });

    if (loading) {
        return <div className={styles.content}>
            <div className={`${styles.size} ${styles.loading}`}>
                <img src={load} width="20px" height="20px" alt="loading" />
            </div>
        </div>
    }

    if (!venda) {
        return <div className={styles.noData}>Venda não encontrada.</div>;
    }

    const createdDate = new Date(venda.created_at);
    let created = createdDate.toLocaleString("pt-PT", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
    }).replace(",", " |");
    
    const purchasedDate = new Date(venda.purchaseDate);
    let purchased = purchasedDate.toLocaleString("pt-PT", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
    }).replace(",", " |");


    const lastPaidDate = new Date(venda.lastPayed);
    let lastPaid = lastPaidDate.toLocaleString("pt-PT", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
    }).replace(",", " |");

    const nextDueDate = new Date(venda.nextDue);
    let nextDue = nextDueDate.toLocaleString("pt-PT", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
    }).replace(",", " |");
    

    if (venda.purchaseDate === null) purchased = null;
    if (venda.lastPayed === null) lastPaid = null;
    if (venda.nextDue === null) nextDue = null;

    return (
        <div className={styles.vendas}>
            <div className={`${styles.venda} ${styles.first} ${styles.last}`}>
                <div className={styles.header}>
                    <div className={styles.image}>
                        <img
                            src={`${venda.serviceImage}`}
                            alt="Imagem do Serviço"
                        />
                    </div>
                    <div className={`${styles.name} ${styles.imagem}`}>
                        <div>{venda.serviceName}</div>
                        <div><span>Id: {venda.serviceId}</span></div>
                    </div>
                </div>
                <div>
                    <div className={styles.topic}>
                        <span className={styles.title}>Id Usuário:</span> {venda.userId}
                    </div>
                    <div className={styles.topic}>
                        <span className={styles.title}>Ciclo de Pagamento:</span> {venda.cycle === "mensal" ? "Mensal" : "Semanal"}
                    </div>
                    <div className={styles.topic}>
                        <span className={styles.title}>Primeiro Pagamento:</span> R${venda.firstValue}
                    </div>
                    <div className={styles.topic}>
                        <span className={styles.title}>Valor {venda.cycle === "mensal" ? "Mensal" : "Semanal"}:</span> R${venda.value}
                    </div>
                    <div className={styles.topic}>
                        <span className={styles.title}>Moeda:</span> {venda.currency}
                    </div>
                    <div className={styles.topic}>
                        <span className={styles.title}>Token BOT:</span> {venda.token || "N/a"}
                    </div>
                    <div className={styles.topic}>
                        <span className={styles.title}>Link Ptero:</span> {venda.ptero || "N/a"}
                    </div>
                    <div className={styles.topic}>
                        <span className={styles.title}>Id do Sistema:</span> {venda.systemId || "N/a"}
                    </div>
                    <div className={styles.topic}>
                        <span className={styles.title}>Data da Compra:</span> {purchased || "N/a"}
                    </div>
                    <div className={styles.topic}>
                        <span className={styles.title}>Ultima vez pago:</span> {lastPaid || "N/a"}
                    </div>
                    <div className={styles.topic}>
                        <span className={styles.title}>Próximo Pagamento:</span> {nextDue || "N/a"}
                    </div>
                    <div className={styles.topic}>
                        <span className={styles.title}>Cancelamento:</span> {venda.cancelamento === "notrequired" ? "Não" : "Sim"}
                    </div>
                    <div className={styles.topic}>
                        <span className={styles.title}>Status:</span> <span className={`${venda.status === "active" ? styles.ativo : (venda.status === "disabled" ? styles.inativo : styles.pendente)}`}>{venda.status === "active" ? "Ativo" : (venda.status === "disabled" ? "Inativo" : "Pendente")}</span>
                    </div>
                    <div className={styles.topic}>
                        <span className={styles.title}>Descrição:</span> {venda.description || "Nenhuma descrição."}
                    </div>
                    <div className={styles.topic}>
                        <span className={styles.title}>Serviço criado a:</span> {created}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Venda;